import { render, staticRenderFns } from "./marketingShop.vue?vue&type=template&id=13d4f5ac&scoped=true"
import script from "./marketingShop.vue?vue&type=script&lang=js"
export * from "./marketingShop.vue?vue&type=script&lang=js"
import style0 from "./marketingShop.vue?vue&type=style&index=0&id=13d4f5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4f5ac",
  null
  
)

export default component.exports